import { c as _c } from "react/compiler-runtime";
import * as RadixDropdown from '@radix-ui/react-dropdown-menu';
import { forwardRef } from 'react';
const GroupTitle = forwardRef<HTMLDivElement, RadixDropdown.DropdownMenuLabelProps>((props, ref) => {
  const $ = _c(3);
  let t0;
  if ($[0] !== props || $[1] !== ref) {
    t0 = <RadixDropdown.Label className="flex px-3 pt-2 pb-1 text-tertiary text-body-2" {...props} ref={ref} />;
    $[0] = props;
    $[1] = ref;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
});
export default GroupTitle;